import React, {useState} from "react";
import { useNavigate } from "react-router-dom";
import { useLoading } from "../Context/LoadingProvider";
import { useTranslation } from "react-i18next";
import { patrollerService } from "../Api/Services/PatrollerService";
import { CalendarIcon } from "../Components/Icons/CalendarIcon";
import DateField from "../Components/InputFields/DateField";
import NumberField from "../Components/InputFields/NumberField";
import TextareaField from "../Components/InputFields/TextAreaField";

const CreateDailyGoalRequest: React.FunctionComponent<object> = () => {
  const navigate = useNavigate();
  const { startLoading, finnishLoading } = useLoading();
  const { t } = useTranslation();
    const [validationErrors, setValidationErrors] = useState<Record<
        string,
        string[]
    > | null>(null);
    const [date, setDate] = useState<string | null>(null);
    const [goal, setGoal] = useState<string | null>(null);
    const [note, setNote] = useState<string | null>(null);

  const handleSubmit = (e: any) => {
    e.preventDefault();
    if (!date || !goal || !note) {
        return;
    }
    startLoading("daily-goal-requests");
        

      patrollerService.createDailyGoalRequest(date, goal, note).then((res) => {
            navigate('/daily-goal-requests');
      }).catch((error) => {
            setValidationErrors(error.errors);
      }).finally(() => {
        finnishLoading("daily-goal-requests");
      });
  }

  return (
    <div className="view-container view-container--stretch background">
      <div className="view-content h-full flex flex-col justify-between">
        <div></div>{/* bottom layout helper */}

        <div className="inner-view-container background-white top-border-radius">
          <div className="inner-view-content">
            
              <div className="heading text-center mb-4">
                    {t("New request")}
              </div>

              <form onSubmit={handleSubmit} className="w-full">
                 
                <div className="mb-4">
                    <div className="text-secondary mb-2">{t("Date")}</div>
                    <DateField 
                        hasError={validationErrors?.date ? true : false}
                        name="date" 
                        icon={<CalendarIcon/>} 
                        onChange={(v) => setDate(v)}
                    />
                </div>

                {validationErrors?.date && (
                    <div className="input-error-text">
                        {validationErrors?.date?.map((x) => (
                            <>
                                <span key={x} style={{ color: "red" }}>{x}</span>
                            </>
                        ))}
                    </div>
                )}


                <div className="mb-4">
                    <div className="text-secondary mb-2">{t("Goal")}</div>
                    <NumberField 
                        hasError={validationErrors?.daily_goal ? true : false}
                        name="goal" 
                        placeholder={t("Goal") + "..."}
                        min={0}
                        max={100}
                        onChange={(v) => setGoal(v)}
                    />
                </div>

                {validationErrors?.daily_goal && (
                    <div className="input-error-text">
                        {validationErrors?.daily_goal?.map((x) => (
                            <>
                                <span key={x} style={{ color: "red" }}>{x}</span>
                            </>
                        ))}
                    </div>
                )}


                <div className="mb-4">
                    <div className="text-secondary mb-2">{t("Note")}</div>
                    <TextareaField 
                        hasError={validationErrors?.note ? true : false}
                        name="note" 
                        placeholder={t("Note") + "..."}
                        rows={4}
                        onChange={(v) => setNote(v)}
                    />
                </div>

                {validationErrors?.note && (
                    <div className="input-error-text">
                        {validationErrors?.note?.map((x) => (
                            <>
                                <span key={x} style={{ color: "red" }}>{x}</span>
                            </>
                        ))}
                    </div>
                )}

                  
                <div className="flex gap-4 mt-8">
                    <div className="flex-1">
                        <button
                            onClick={() => {
                                navigate('/daily-goal-requests')
                            }}
                            className="button button--light"
                        >
                            {t("Cancel")}
                        </button>
                    </div>

                    <div className="flex-1">
                        <button type="submit" className="button">
                            {t("Submit")}
                        </button>
                    </div>
                </div>

             </form>

          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateDailyGoalRequest;
